import logo from './logo.svg';
import './App.css';

import ArchitecturePortfolio from './screens/SecondScreen';
import ArchitectHeroCarousel from './screens/FirstScreen';

import RoeiProfile from './components/me/Me';
import ForthScreen from './screens/ForthScreen';
import Timeline from './components/steps/Steps';
import SixthScreen from './screens/SixthScreen';
import SeventhScreen from './screens/SeventhScreen';
import ByMe from './components/ByMe/ByMe';
import PrivacyPolicy from "./components/privacy/Privacy"

function App() {
  return <>
  <ArchitectHeroCarousel/>
  <ForthScreen/>
<RoeiProfile/>
 <ArchitecturePortfolio/>
<SixthScreen/>
<SeventhScreen/>
<PrivacyPolicy 
  ownerName="רועי שמואל" 
  email="royshm22@gmail.com" 
  phone="+972 54-521-5216" 
  domain="https://www.consilium-israel.co.il/" 
/>
<ByMe/>
  </>
}

export default App;
